import React from "react";

const Programs = () => {
  return (
    <div>
      <h1 className="text-center" style={{ color: "#2f3778" }}>
        Our Programs
      </h1>
    </div>
  );
};

export default Programs;
